<template>
  <div id="app" tabindex="-1">
    <title-container title="My24 Account"></title-container>
    <registration-header></registration-header>
    <router-view></router-view>
  </div>
</template>

<script>
  import { TitleContainer } from 'my-account-common-vue'
  import RegistrationHeader from '@/components/RegistrationHeader.vue'

  export default {
    components: {
      TitleContainer,
      RegistrationHeader
    },
    name: 'app'
  }
</script>

<style lang="scss">
  $fa-font-path: "~font-awesome/fonts";
  @import "~font-awesome/scss/font-awesome";
  @import "~material-design-icons-iconfont/dist/fonts/material-icons.css";

  #app {

    &:focus {

      outline: none;

    }

  }

</style>



// WEBPACK FOOTER //
// src/App.vue